import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-028f11a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"display":"grid","gap":"10px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"18px","font-weight":"bold"} }, "备案提交失败", -1))
const _hoisted_3 = { style: {"font-size":"16px","font-weight":"500"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "建议", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 5px"} }, "~", -1))
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin":"0 5px"} }, "~", -1))
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#999"} }, "请具体描述小程序实际经营内容、主要服务内容，该信息为主管部门审核重要依据，备注内容字数限制20-200字，请认真填写。（特殊备注要求请查看注意事项）", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "submit-fixed-wrap-placeholder" }, null, -1))
const _hoisted_24 = { class: "submit-fixed-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_title = _resolveComponent("ui-title")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ui_form, {
      ref: "form",
      "label-position": "right",
      "label-width": "140px"
    }, {
      default: _withCtx(() => [
        (_ctx.remoteInfo && _ctx.remoteInfo.errorList && _ctx.remoteInfo.errorList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remoteInfo.errorList, (item, i) => {
                return (_openBlock(), _createElementBlock("div", { key: i }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(i + 1) + "." + _toDisplayString(item.key_name), 1),
                  _createElementVNode("div", null, _toDisplayString(item.error), 1),
                  (item.suggest)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", {
                          style: {"display":"inline-block"},
                          innerHTML: item.suggest
                        }, null, 8, _hoisted_6)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "企业信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "选择地区",
              data: _ctx.areaCode,
              required: true,
              error: "请选择地址"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: _ctx.areaCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.areaCode) = $event)),
                  options: _ctx.areaOptions,
                  placeholder: "请选择地区"
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["data"]),
            (_ctx.areaCode[0] == '440000')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ui_form_item, {
                    label: "信息承诺书",
                    data: _ctx.formData.icp_materials.commitment_letter,
                    required: true,
                    error: "请上传互联网承诺书"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadPromiseBook('icp_materials.commitment_letter')))
                      }, [
                        (_ctx.showData[_ctx.formData.icp_materials.commitment_letter[0]])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.showData[_ctx.formData.icp_materials.commitment_letter[0]],
                              style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                            }, null, 8, _hoisted_8))
                          : (_openBlock(), _createElementBlock("div", _hoisted_9, " 请上传互联网承诺书 "))
                      ])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, { label: " " }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_link, {
                        type: "primary",
                        href: "https://res.wx.qq.com/op_res/HoIJ34sposVj1qLmnNVe6oyeZux7LVTEXBMpLeOfgqUAZ_HLm1OHDgFCPaMFNDLhw-kEBDVxkd1_dd044yHUIQ",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("承诺书下载")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_link, {
                        type: "primary",
                        style: {"margin-left":"20px"},
                        href: "https://developers.weixin.qq.com/miniprogram/product/record/record_material.html#_1-%E5%B9%BF%E4%B8%9C%E7%9C%81%E4%BA%92%E8%81%94%E7%BD%91%E4%BF%A1%E6%81%AF%E6%9C%8D%E5%8A%A1%E6%89%BF%E8%AF%BA%E4%B9%A6%EF%BC%88%E5%8D%95%E4%BD%8D%EF%BC%89",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("填写示例")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_ui_form_item, {
              label: "主办者性质",
              data: _ctx.formData.icp_subject.base_info.type,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.icp_subject.base_info.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.icp_subject.base_info.type) = $event)),
                  placeholder: "请选择主办者性质"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icpSubject, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.type,
                        label: item.name,
                        value: item.type
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件类型",
              data: _ctx.formData.icp_subject.organize_info.certificate_type,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.icp_subject.organize_info.certificate_type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.icp_subject.organize_info.certificate_type) = $event)),
                  placeholder: "请选择证件类型"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificateList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.type,
                        label: item.name,
                        value: item.type
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "企业名称",
              data: _ctx.formData.icp_subject.base_info.name,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.base_info.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.icp_subject.base_info.name) = $event)),
                  placeholder: "请输入企业名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件住所",
              data: _ctx.formData.icp_subject.organize_info.certificate_address,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.organize_info.certificate_address,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.icp_subject.organize_info.certificate_address) = $event)),
                  placeholder: "请输入证件住所"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件号码",
              data: _ctx.formData.icp_subject.organize_info.certificate_number,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.organize_info.certificate_number,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.icp_subject.organize_info.certificate_number) = $event)),
                  placeholder: "请输入证件号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "实际地址",
              rule: _ctx.valiteRealAddress,
              data: _ctx.formData.icp_subject.base_info.address,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.base_info.address,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.icp_subject.base_info.address) = $event)),
                  placeholder: "请输入实际地址，请勿填写省市区"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["rule", "data"]),
            (_ctx.formData.icp_subject.organize_info.certificate_type)
              ? (_openBlock(), _createBlock(_component_ui_form_item, {
                  key: 1,
                  label: "企业证件",
                  data: _ctx.formData.icp_subject.organize_info.certificate_photo,
                  required: true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd"},
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.uploadFiles('icp_subject.organize_info.certificate_photo', _ctx.formData.icp_subject.organize_info.certificate_type)))
                    }, [
                      (_ctx.showData[_ctx.formData.icp_subject.organize_info.certificate_photo])
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.showData[_ctx.formData.icp_subject.organize_info.certificate_photo],
                            style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                          }, null, 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("div", _hoisted_11, " 请上传证件照片 "))
                    ])
                  ]),
                  _: 1
                }, 8, ["data"]))
              : _createCommentVNode("", true),
            _createVNode(_component_ui_form_item, {
              label: "备注",
              data: _ctx.formData.icp_subject.base_info.comment
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.base_info.comment,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.icp_subject.base_info.comment) = $event)),
                  placeholder: "备注可为空"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "ICP认证人信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "姓名",
              data: _ctx.formData.icp_subject.principal_info.name,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.principal_info.name,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.name) = $event)),
                  placeholder: "请输入姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "手机",
              data: _ctx.formData.icp_subject.principal_info.mobile,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.principal_info.mobile,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.mobile) = $event)),
                  placeholder: "请输入手机"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "邮箱",
              data: _ctx.formData.icp_subject.principal_info.email,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.principal_info.email,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.email) = $event)),
                  placeholder: "请输入邮箱"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "紧急联系方式",
              data: _ctx.formData.icp_subject.principal_info.emergency_contact,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.principal_info.emergency_contact,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.emergency_contact) = $event)),
                  placeholder: "请输入紧急联系方式"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件类型",
              data: _ctx.formData.icp_subject.principal_info.certificate_type,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.icp_subject.principal_info.certificate_type,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.certificate_type) = $event)),
                  placeholder: "请选择主办者性质"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.type,
                        label: item.name,
                        value: item.type
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "证件号码",
              data: _ctx.formData.icp_subject.principal_info.certificate_number,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_subject.principal_info.certificate_number,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.certificate_number) = $event)),
                  placeholder: "请输入证件号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "有效期",
              rule: _ctx.validateTime,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  "value-format": "YYYYMMDD",
                  modelValue: _ctx.formData.icp_subject.principal_info.certificate_validity_date_start,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.certificate_validity_date_start) = $event)),
                  type: "date",
                  placeholder: "证件开始日期"
                }, null, 8, ["modelValue"]),
                _createTextVNode(),
                (_ctx.formData.icp_subject.principal_info.certificate_validity_date_end != '长期')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_12,
                      _createVNode(_component_el_date_picker, {
                        "value-format": "YYYYMMDD",
                        modelValue: _ctx.formData.icp_subject.principal_info.certificate_validity_date_end,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.icp_subject.principal_info.certificate_validity_date_end) = $event)),
                        type: "date",
                        placeholder: "证件结束日期"
                      }, null, 8, ["modelValue"])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_checkbox, {
                  style: {"margin-left":"10px"},
                  onInput: _cache[18] || (_cache[18] = (v) => { _ctx.formData.icp_subject.principal_info.certificate_validity_date_end = _ctx.formData.icp_subject.principal_info.certificate_validity_date_end == '长期' ? '' : '长期' }),
                  "model-value": _ctx.formData.icp_subject.principal_info.certificate_validity_date_end == '长期'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("长期")
                  ]),
                  _: 1
                }, 8, ["model-value"])
              ]),
              _: 1
            }, 8, ["rule"]),
            _createVNode(_component_ui_form_item, {
              label: "请上传证件",
              error: "请上传证件照",
              data: _ctx.formData.icp_subject.principal_info.certificate_photo_front && _ctx.formData.icp_subject.principal_info.certificate_photo_back ? 'a' : '',
              required: true
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd"},
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.uploadFiles('icp_subject.principal_info.certificate_photo_front', _ctx.formData.icp_subject.principal_info.certificate_type)))
                }, [
                  (_ctx.showData[_ctx.formData.icp_subject.principal_info.certificate_photo_front])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.showData[_ctx.formData.icp_subject.principal_info.certificate_photo_front],
                        style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                      }, null, 8, _hoisted_13))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, " 请上传证件正面照 "))
                ]),
                _createElementVNode("div", {
                  style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd","margin-left":"20px"},
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.uploadFiles('icp_subject.principal_info.certificate_photo_back', _ctx.formData.icp_subject.principal_info.certificate_type)))
                }, [
                  (_ctx.showData[_ctx.formData.icp_subject.principal_info.certificate_photo_back])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.showData[_ctx.formData.icp_subject.principal_info.certificate_photo_back],
                        style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                      }, null, 8, _hoisted_15))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, " 请上传证件反面照 "))
                ])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "小程序管理员信息" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.principalIsSame,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.principalIsSame) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("与ICP管理员相同")
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (!_ctx.principalIsSame)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ui_form_item, {
                    label: "姓名",
                    data: _ctx.formData.icp_applets.principal_info.name,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.icp_applets.principal_info.name,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.name) = $event)),
                        placeholder: "请输入姓名"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, {
                    label: "手机",
                    data: _ctx.formData.icp_applets.principal_info.mobile,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.icp_applets.principal_info.mobile,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.mobile) = $event)),
                        placeholder: "请输入手机"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, {
                    label: "邮箱",
                    data: _ctx.formData.icp_applets.principal_info.email,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.icp_applets.principal_info.email,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.email) = $event)),
                        placeholder: "请输入邮箱"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, {
                    label: "紧急联系方式",
                    data: _ctx.formData.icp_applets.principal_info.emergency_contact,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.icp_applets.principal_info.emergency_contact,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.emergency_contact) = $event)),
                        placeholder: "请输入紧急联系方式"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, {
                    label: "证件类型",
                    data: _ctx.formData.icp_applets.principal_info.certificate_type,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.icp_applets.principal_info.certificate_type,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.certificate_type) = $event)),
                        placeholder: "请选择主办者性质"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalList, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.type,
                              label: item.name,
                              value: item.type
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, {
                    label: "证件号码",
                    data: _ctx.formData.icp_applets.principal_info.certificate_number,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.icp_applets.principal_info.certificate_number,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.certificate_number) = $event)),
                        placeholder: "请输入证件号码"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["data"]),
                  _createVNode(_component_ui_form_item, {
                    label: "有效期",
                    rule: _ctx.validateTime,
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        "value-format": "YYYYMMDD",
                        modelValue: _ctx.formData.icp_applets.principal_info.certificate_validity_date_start,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.certificate_validity_date_start) = $event)),
                        type: "date",
                        placeholder: "证件开始日期"
                      }, null, 8, ["modelValue"]),
                      _createTextVNode(),
                      (_ctx.formData.icp_applets.principal_info.certificate_validity_date_end != '长期')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_17,
                            _createVNode(_component_el_date_picker, {
                              "value-format": "YYYYMMDD",
                              modelValue: _ctx.formData.icp_applets.principal_info.certificate_validity_date_end,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.icp_applets.principal_info.certificate_validity_date_end) = $event)),
                              type: "date",
                              placeholder: "证件结束日期"
                            }, null, 8, ["modelValue"])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_checkbox, {
                        style: {"margin-left":"10px"},
                        onInput: _cache[30] || (_cache[30] = (v) => { _ctx.formData.icp_applets.principal_info.certificate_validity_date_end = _ctx.formData.icp_applets.principal_info.certificate_validity_date_end == '长期' ? '' : '长期' }),
                        "model-value": _ctx.formData.icp_applets.principal_info.certificate_validity_date_end == '长期'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("长期")
                        ]),
                        _: 1
                      }, 8, ["model-value"])
                    ]),
                    _: 1
                  }, 8, ["rule"]),
                  _createVNode(_component_ui_form_item, {
                    label: "请上传证件",
                    error: "请上传证件照",
                    data: _ctx.formData.icp_applets.principal_info.certificate_photo_front && _ctx.formData.icp_applets.principal_info.certificate_photo_back ? 'a' : '',
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd"},
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.uploadFiles('icp_applets.principal_info.certificate_photo_front', _ctx.formData.icp_applets.principal_info.certificate_type)))
                      }, [
                        (_ctx.showData[_ctx.formData.icp_applets.principal_info.certificate_photo_front])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.showData[_ctx.formData.icp_applets.principal_info.certificate_photo_front],
                              style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                            }, null, 8, _hoisted_18))
                          : (_openBlock(), _createElementBlock("div", _hoisted_19, " 请上传证件正面照 "))
                      ]),
                      _createElementVNode("div", {
                        style: {"width":"200px","height":"140px","display":"flex","align-items":"center","justify-content":"center","border":"1px solid #ddd","margin-left":"20px"},
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.uploadFiles('icp_applets.principal_info.certificate_photo_back', _ctx.formData.icp_applets.principal_info.certificate_type)))
                      }, [
                        (_ctx.showData[_ctx.formData.icp_applets.principal_info.certificate_photo_back])
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.showData[_ctx.formData.icp_applets.principal_info.certificate_photo_back],
                              style: {"width":"100%","height":"100%","display":"block","object-fit":"contain"}
                            }, null, 8, _hoisted_20))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, " 请上传证件反面照 "))
                      ])
                    ]),
                    _: 1
                  }, 8, ["data"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_card, null, {
          title: _withCtx(() => [
            _createVNode(_component_ui_title, { title: "小程序相关" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_ui_form_item, {
              label: "前置审批",
              data: _ctx.nrlxDetails,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  multiple: true,
                  modelValue: _ctx.nrlxDetails,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.nrlxDetails) = $event)),
                  placeholder: "请选择前置审批",
                  clearable: false
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icpNrlx, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.type,
                        label: item.name,
                        value: item.type
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "服务内容",
              data: _ctx.serviceContentValue,
              required: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  "show-all-levels": false,
                  modelValue: _ctx.serviceContentValue,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.serviceContentValue) = $event)),
                  options: _ctx.serviceContentType.list,
                  props: { multiple: true },
                  clearable: ""
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_ui_form_item, {
              label: "备注",
              data: _ctx.formData.icp_applets.base_info.comment,
              rule: _ctx.ruleComment,
              required: true
            }, {
              default: _withCtx(() => [
                _hoisted_22,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.icp_applets.base_info.comment,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.icp_applets.base_info.comment) = $event)),
                  placeholder: "请输入备注"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["data", "rule"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _hoisted_23,
    _createElementVNode("div", _hoisted_24, [
      _withDirectives((_openBlock(), _createBlock(_component_el_button, { onClick: _ctx.withdrawAudit }, {
        default: _withCtx(() => [
          _createTextVNode("撤回申请")
        ]),
        _: 1
      }, 8, ["onClick"])), [
        [_directive_loading, _ctx.submitLoading]
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _ctx.submit,
        disabled: _ctx.disabledSubmit,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("提交审核")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])), [
        [_directive_loading, _ctx.submitLoading]
      ])
    ])
  ]))
}